/**
 * Loại trong bộ lọc chứng từ
 */
export default {
  DateTime: 1, // Ngày tháng
  Text: 2, // Chữ
  ComboBox: 3, // Kiểu combo
  Amount: 4, // Kiểu tiền
  Quantity: 11, // Kiểu số lượng
};
